module.exports = __webpack_public_path__ + "img/code.e913d9f8.png";